export default __webpack_public_path__ + "static/media/banner20260517.c2798846.jpg";